import axios from 'axios'
import {vm} from '@/main'

var baseUrl = process.env.VUE_APP_BASE_URL

const cleanings = {
    state: {
        cleaning: null,
        cleanings: null,
        cleaningInputData: null,
        showAddCleaningForm: false,
        showUpdateCleaningForm: false,
        selectedCleaningOptions: []
    },

    mutations: {
        setCleanings(state, cleanings){
            state.cleanings = cleanings
        },
        setSingleCleaning(state, cleaning){
            state.cleaning = cleaning
        },
        setCleaningInputData(state, payload){
            state.cleaningInputData = payload
        },
        showAddCleaningForm(state){
            state.showAddCleaningForm = true
        },
        hideAddCleaningForm(state){
            state.showAddCleaningForm = false
        },
        showUpdateCleaningForm(state){
            state.showUpdateCleaningForm = true
        },
        hideUpdateCleaningForm(state){
            state.showUpdateCleaningForm = false
        },
        setSelectedCleaningOptions(state, allOptions){
            state.selectedCleaningOptions = allOptions.filter((option) => {
                return state.cleaning.cleaningOptions.some((selectedCleaningOption) => {
                    return option.id === selectedCleaningOption.option_id;
                });
            });
        },
        resetSelectedCleaningOptions(state){
            return state.selectedCleaningOptions = []
        },
        setCleaningOptions(state, options){
            return state.selectedCleaningOptions = options
        }
    },

    actions: {
        getCleanings({ commit, rootState, dispatch, state }, page){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/search_cleanings?page='+page +'&q='+rootState.search)
                    .then(response => {
                        commit('setCleanings', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        getSingleCleaning({ commit, rootState, dispatch, state }, cleaningId){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/cleanings/'+cleaningId)
                    .then(response => {
                        commit('setSingleCleaning', response.data.cleaning)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        getCleaningInputData({ commit, rootState, dispatch }){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/cleanings/create')
                    .then(response => {
                        commit('setCleaningInputData', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        getUpdateCleaningInputData({ commit, rootState, dispatch }){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/cleanings/create')
                    .then(response => {
                        commit('resetSelectedCleaningOptions')
                        commit('setCleaningInputData', response.data)
                        commit('setSelectedCleaningOptions', response.data.options)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        createNewCleaning({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/cleanings', {
                    cleaning_item_id: formData.cleaningItemId,
                    cleaning_type: formData.cleaningType,
                    truck_id: formData.truckId,
                    trailer_id: formData.trailerId,
                    company_id: formData.customerId,
                    cargo_id: formData.cargoId,
                    cleaning_options: formData.options,
                    cleaning_date: formData.cleaningDate,
                    start_time: formData.startTime,
                    end_time: formData.endTime,
                    tank_compartments: formData.tankCompartments,
                    additional_services: formData.additionalServices,
                    certificate_nr: formData.certificateNr,
                    cleaning_order_nr: formData.cleaningOrderNr,
                    leftovers: formData.leftovers,
                })
                    .then(response => {
                        dispatch('getCleanings')
                        commit('hideAddCleaningForm')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        if (error.response.status === 422) {
                            commit('setErrorMessage', error.response.data.errors.cleaning_options[0])
                        }
                        reject(error)
                    })
            })
        },
        updateCleaning({ commit, rootState, dispatch, state }){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.patch(baseUrl +'/api/cleanings/'+ state.cleaning.id, {
                    truck_id: state.cleaning.truck ? state.cleaning.truck.id : null,
                    trailer_id: state.cleaning.trailer ? state.cleaning.trailer.id : null,
                    company_id: state.cleaning.customer.id,
                    cargo_id: state.cleaning.cargo.id,
                    cleaning_date: state.cleaning.cleaning_date,
                    start_time: state.cleaning.start_time,
                    end_time: state.cleaning.end_time,
                    tank_compartments: state.cleaning.tank_compartments,
                    additional_services: state.cleaning.additional_services,
                    leftovers: state.cleaning.leftovers,
                    cleaning_order_nr: state.cleaning.cleaning_order_nr,
                    cleaning_options: state.selectedCleaningOptions
                })
                    .then(response => {
                        dispatch('getSingleCleaning', state.cleaning.id)
                        commit('hideUpdateCleaningForm')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        if (error.response.status === 422) {
                            commit('setErrorMessage', error.response.data.errors.cleaning_options[0])
                        }
                        reject(error)
                    })
            })
        },

        changeSelectedCleaningOptions({commit}, options) {
            commit('setCleaningOptions', options)
        },
        addCertificate({ commit, rootState, dispatch, state }, certificateNr){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/certificates', {
                    cleaning_id: state.cleaning.id,
                    certificate_nr: certificateNr,
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getSingleCleaning', state.cleaning.id)
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },
        deleteCertificate({commit, rootState, dispatch, state}, certificateId){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.delete(baseUrl +'/api/certificates/'+certificateId)
                    .then(response => {
                        dispatch('getSingleCleaning', state.cleaning.id)
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        deleteCleaning({commit, rootState, dispatch, state}, cleaningId){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.delete(baseUrl +'/api/cleanings/'+cleaningId)
                    .then(response => {
                        dispatch('getCleanings')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },

        showAddCleaningForm({ commit }){
            commit('showAddCleaningForm')
        },
        hideAddCleaningForm({ commit }){
            commit('hideAddCleaningForm')
        },
        showUpdateCleaningForm({ commit }){
            commit('showUpdateCleaningForm')
        },
        hideUpdateCleaningForm({ commit }){
            commit('hideUpdateCleaningForm')
        },
        resetSelectedCleaningOptions({ commit }){
            commit('resetSelectedCleaningOptions')}
    },
    getters: {
        cleaning(state){
            return state.cleaning
        },
        cleanings(state){
            return state.cleanings
        },
        cleaningInputData(state){
            return state.cleaningInputData
        },
        showAddCleaningForm(state){
            return state.showAddCleaningForm
        },
        showUpdateCleaningForm(state){
            return state.showUpdateCleaningForm
        },
        selectedCleaningOptions(state){
            return state.selectedCleaningOptions
        }
    }
}

export default cleanings